import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'module-tsl-ui-modal';
import { Elements, StripeProvider } from 'react-stripe-elements';
import { amount, countryCode, price as priceType } from './components/types';
import PaymentForm from './components/PaymentForm';

var CheckoutModal = function CheckoutModal(_ref) {
  var show = _ref.show,
      price = _ref.price,
      cardCharge = _ref.cardCharge,
      items = _ref.items,
      isForex = _ref.isForex,
      balanceBefore = _ref.balanceBefore,
      balanceAfter = _ref.balanceAfter,
      buttonDisabled = _ref.buttonDisabled,
      siteCountry = _ref.siteCountry,
      geoCountry = _ref.geoCountry,
      isBalanceOnly = _ref.isBalanceOnly,
      paymentError = _ref.paymentError,
      paymentInProgressError = _ref.paymentInProgressError,
      submitted = _ref.submitted,
      discountCode = _ref.discountCode,
      discountCodeError = _ref.discountCodeError,
      reloadCheckout = _ref.reloadCheckout,
      inputFocused = _ref.inputFocused,
      checkoutLoading = _ref.checkoutLoading,
      discountCodeApplied = _ref.discountCodeApplied,
      isPostalCodeNeeded = _ref.isPostalCodeNeeded,
      isEmailConfirmationNeeded = _ref.isEmailConfirmationNeeded,
      countryCodes = _ref.countryCodes,
      safeFields = _ref.safeFields,
      safeFieldsValidation = _ref.safeFieldsValidation,
      singlePrice = _ref.singlePrice,
      schoolLicPrice = _ref.schoolLicPrice,
      mtl_multiplier = _ref.mtl_multiplier,
      multiTeachingLicCheckboxId = _ref.multiTeachingLicCheckboxId,
      isMultiTeacherLicence = _ref.isMultiTeacherLicence,
      pay = _ref.pay,
      setSubmitted = _ref.setSubmitted,
      showDiscountCodeInput = _ref.showDiscountCodeInput,
      setDiscountCode = _ref.setDiscountCode,
      setInputFocus = _ref.setInputFocus,
      clearDiscountCode = _ref.clearDiscountCode,
      onHideModal = _ref.onHideModal,
      setMultiTeacherLicence = _ref.setMultiTeacherLicence,
      setSafeFields = _ref.setSafeFields,
      stripePublishableKey = _ref.stripePublishableKey,
      submitPaymentToStripe = _ref.submitPaymentToStripe,
      paymentResponse = _ref.paymentResponse,
      successMessage = _ref.successMessage,
      loadCountryCodes = _ref.loadCountryCodes,
      isStripeLoading = _ref.isStripeLoading,
      featureStripe = _ref.featureStripe,
      title = _ref.title,
      resourceThumbnailUrl = _ref.resourceThumbnailUrl,
      resourceAuthorUsername = _ref.resourceAuthorUsername;
  return /*#__PURE__*/React.createElement("div", {
    className: "payment payment-fullpage ".concat(show ? 'payment-b' : 'hidden')
  }, /*#__PURE__*/React.createElement(Modal, {
    showModal: show,
    backdrop: "static",
    animation: true,
    id: "ResourceSummaryPaymentModal",
    size: "lg",
    onHideModal: onHideModal
  }, /*#__PURE__*/React.createElement(StripeProvider, {
    apiKey: stripePublishableKey
  }, /*#__PURE__*/React.createElement(Elements, null, /*#__PURE__*/React.createElement(PaymentForm, {
    price: price,
    cardCharge: cardCharge,
    items: items,
    isForex: isForex,
    balanceBefore: balanceBefore,
    balanceAfter: balanceAfter,
    buttonDisabled: buttonDisabled,
    siteCountry: siteCountry,
    geoCountry: geoCountry,
    isBalanceOnly: isBalanceOnly,
    paymentError: paymentError,
    paymentInProgressError: paymentInProgressError,
    submitted: submitted,
    discountCode: discountCode,
    discountCodeError: discountCodeError,
    inputFocused: inputFocused,
    checkoutLoading: checkoutLoading,
    discountCodeApplied: discountCodeApplied,
    isPostalCodeNeeded: isPostalCodeNeeded,
    isEmailConfirmationNeeded: isEmailConfirmationNeeded,
    countryCodes: countryCodes,
    safeFields: safeFields,
    safeFieldsValidation: safeFieldsValidation,
    singlePrice: singlePrice,
    schoolLicPrice: schoolLicPrice,
    mtl_multiplier: mtl_multiplier // eslint-disable-line camelcase
    ,
    multiTeachingLicCheckboxId: multiTeachingLicCheckboxId,
    isMultiTeacherLicence: isMultiTeacherLicence,
    pay: pay,
    clearDiscountCode: clearDiscountCode,
    setDiscountCode: setDiscountCode,
    showDiscountCodeInput: showDiscountCodeInput,
    setInputFocus: setInputFocus,
    reloadCheckout: reloadCheckout,
    setSafeFields: setSafeFields,
    setSubmitted: setSubmitted,
    setMultiTeacherLicence: setMultiTeacherLicence,
    submitPaymentToStripe: submitPaymentToStripe,
    paymentResponse: paymentResponse,
    successMessage: successMessage,
    loadCountryCodes: loadCountryCodes,
    isStripeLoading: isStripeLoading,
    featureStripe: featureStripe,
    title: title,
    resourceThumbnailUrl: resourceThumbnailUrl,
    resourceAuthorUsername: resourceAuthorUsername
  })))));
};

CheckoutModal.displayName = "CheckoutModal";
CheckoutModal.propTypes = {
  onHideModal: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  balanceAfter: amount.isRequired,
  balanceBefore: amount.isRequired,
  buttonDisabled: PropTypes.bool.isRequired,
  cardCharge: amount.isRequired,
  siteCountry: PropTypes.string.isRequired,
  geoCountry: PropTypes.string.isRequired,
  isBalanceOnly: PropTypes.bool.isRequired,
  isForex: PropTypes.bool.isRequired,
  pay: PropTypes.func.isRequired,
  paymentError: PropTypes.object,
  paymentInProgressError: PropTypes.bool,
  price: priceType.isRequired,
  submitted: PropTypes.bool.isRequired,
  setSubmitted: PropTypes.func.isRequired,
  discountCode: PropTypes.string.isRequired,
  showDiscountCodeInput: PropTypes.func.isRequired,
  setDiscountCode: PropTypes.func.isRequired,
  discountCodeError: PropTypes.string,
  reloadCheckout: PropTypes.func.isRequired,
  setInputFocus: PropTypes.func.isRequired,
  inputFocused: PropTypes.bool.isRequired,
  checkoutLoading: PropTypes.bool.isRequired,
  clearDiscountCode: PropTypes.func.isRequired,
  discountCodeApplied: PropTypes.bool.isRequired,
  isPostalCodeNeeded: PropTypes.bool.isRequired,
  isEmailConfirmationNeeded: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  resourceThumbnailUrl: PropTypes.string.isRequired,
  resourceAuthorUsername: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
    price: priceType.isRequired,
    owns: PropTypes.bool.isRequired,
    warnings: PropTypes.object,
    author: PropTypes.string,
    thumbnailUrl: PropTypes.string
  })).isRequired,
  setSafeFields: PropTypes.func.isRequired,
  countryCodes: PropTypes.arrayOf(countryCode).isRequired,
  safeFields: PropTypes.object,
  safeFieldsValidation: PropTypes.object,
  singlePrice: priceType,
  schoolLicPrice: priceType,
  mtl_multiplier: PropTypes.number.isRequired,
  setMultiTeacherLicence: PropTypes.func.isRequired,
  multiTeachingLicCheckboxId: PropTypes.string.isRequired,
  isMultiTeacherLicence: PropTypes.bool.isRequired,
  stripePublishableKey: PropTypes.string.isRequired,
  submitPaymentToStripe: PropTypes.func.isRequired,
  paymentResponse: PropTypes.object,
  successMessage: PropTypes.string.isRequired,
  loadCountryCodes: PropTypes.func.isRequired,
  isStripeLoading: PropTypes.bool.isRequired,
  featureStripe: PropTypes.bool.isRequired
};
export default CheckoutModal;